import React from 'react'

interface DescriptionStepProps {
  value: string
  onChange: (value: string) => void
}

const DescriptionStep = ({ value, onChange }: DescriptionStepProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
    <div>
      <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>Describe the problem in your own words</h3>
      <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: 0 }}>Any additional details you can provide will help us resolve the issue faster.</p>
    </div>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g. The pipe under the kitchen sink started leaking last night. Water is collecting under the cabinet..."
      rows={7}
      style={{
        padding: '12px 14px',
        borderRadius: '8px',
        border: '1.5px solid #e5e7eb',
        fontSize: '0.875rem',
        color: '#374151',
        outline: 'none',
        resize: 'vertical',
        width: '100%',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
      }}
    />
    <p style={{ fontSize: '0.8125rem', color: '#9ca3af', margin: 0 }}>
      This field is optional. You may leave it blank and click Next.
    </p>
  </div>
)

export default DescriptionStep
